import React from "react";
import "../styles/colorPalette.css";

interface ColorCardProps {
  colorName: string;
  hexValue: string;
}

const ColorCard: React.FC<ColorCardProps> = ({ colorName, hexValue }) => {
  return (
    <div className="color-card" style={{ backgroundColor: hexValue }}>
      <div className="color-swatch" style={{ backgroundColor: hexValue }}></div>
      <div className="color-info">
        <div className="color-label">{colorName}</div>
        <div className="color-hex">{hexValue}</div>
      </div>
    </div>
  );
};

export default ColorCard;
